import { FrenchSeries } from "../components/FrenchSeries";
import { ProductShowcase } from "../components/ProductShowcase";
import { useProductsByCategory } from "../catalog";

export default function FrenchPage({ onAdd }) {
    const products = useProductsByCategory("french");
    return (
        <div data-testid="french-page" className="pt-16 sm:pt-20">
            <FrenchSeries />
            {products.map((p, i) => (
                <ProductShowcase key={p.id} product={p} index={i} reversed={i % 2 === 1} tint={i % 2 === 1 ? "bg-cream" : "bg-ivory"} onAdd={onAdd} />
            ))}
        </div>
    );
}
